import { FC } from 'react';
import { ReactComponent as UploadArrowIcon } from '../../../../../common/icon/upload/arrow.svg';
import { ReactComponent as UploadBoxIcon } from '../../../../../common/icon/upload/box.svg';
import translation from '../../../../../languages';
import './upload-btn.scss';
import CustomLink from '../../../../../common/custom-link';
import { domainLinkCreator } from '../../../../../utils/domain-manager';

type UploadBtnProps = TranslationProps & {
    link: string;
};

const UploadBtn: FC<UploadBtnProps> = ({ link, t }) => (
    <div className='d-none d-lg-flex justify-content-center align-items-center header-upload-btn'>
        <div>
            <CustomLink className='d-flex flex-column align-items-center justify-content-between' to={domainLinkCreator(link)}>
                <div className='share-icon-wrapper'>
                    <UploadArrowIcon className='share-arrow-icon' />
                    <UploadBoxIcon className='share-box-icon' height='30' />
                </div>
                <div className='upload-text'>{t('header.icons.upload')}</div>
            </CustomLink>
        </div>
    </div>
);

const translate = translation('header');

export default translate(UploadBtn);
